import React from 'react';
import { gridRowHeightInteger } from '@/list/list-constants';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: ${gridRowHeightInteger}px;
  line-height: 1;
`;

const InnerWrapper = styled.div`
  border-bottom: solid 2px rgba(89, 126, 247, 0.25);
  /* Prevents text from being higher than the checkbox. Ag-grid adds a mysterious 2px padding
     to every container */
  margin-top: 2px;
`;

export function AddressCell({ data, node }) {
  // if we are dealing with a single row, data will be defined as a prop

  // data is undefined for a row group cell so we have to access the data from the children rows
  // we can fetch the first row's data since the fact that we have a group guarantees one child
  let rowData = null;

  if (node.group) {
    rowData = data || node?.allLeafChildren?.[0]?.data;
  } else {
    rowData = data;
  }

  if (!rowData) return <div />;

  return (
    <Wrapper>
      <InnerWrapper>{rowData?.address}</InnerWrapper>
    </Wrapper>
  );
}
